import i18nNext from "i18next";
import { initReactI18next } from "react-i18next";

import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en-gb.json";
import de from "./de.json";
import fr from "./fr.json";
import it from "./it.json";
import nl from "./nl.json";

const resources = {
  "en-GB": en,
  de,
  fr,
  it,
  nl,
};
const locales = Object.keys(resources);

export const getLanguages = () => locales;
export const getCurrentLocale = () =>
  i18nNext.languages.find((lng) => locales.indexOf(lng) !== -1);

i18nNext
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en-GB",
    resources,
    interpolation: { escapeValue: false },
  })
  .then();

export const changeLanguage = (lng) => i18nNext.changeLanguage(lng);

export const i18n = i18nNext;
